import { getFullUrl } from 'hubspot-url-utils'; // @ts-expect-error Untyped module

import HubSpotOnlyAppCookieLogin from 'Nabisco/app/HubSpotOnlyAppCookieLogin';
import { HubletOption } from 'signup-constants/signupData/HubletOption';
import Url from 'urlinator/Url';
import { getSentryExtra } from '../error/getSentryExtra';
import noAuthApiClient from '../http/noAuthApiClient';
import Logger from '../lib/Logger';
import { Tracker } from '../store/tracking/action-creators';
const LOG = Logger.getLogger('LoginClient');

const promiseDelay = function promiseDelay(timeout) {
  return new Promise(resolve => {
    setTimeout(resolve, timeout);
  });
};

const retry = function retry({
  fn,
  delay = 10000,
  tries = 2,
  dispatch
}) {
  let numTries = 0;
  let lastError;

  const check = (resolve, reject) => {
    if (numTries >= tries) {
      reject(new Error(`retryUntil exceeded max tries. Last error: ${lastError}`));
    }

    ++numTries;
    return fn().then(() => {
      dispatch(Tracker.loginSuccess(numTries));
      resolve(true);
    }).catch(err => {
      lastError = err;
      return promiseDelay(delay).then(() => {
        LOG.error('Login Retry Triggered', {
          extra: getSentryExtra(err)
        });
        dispatch(Tracker.signupInteraction('login-retry'));
        check(resolve, reject).catch(error => {
          throw error;
        });
      }).catch(error => LOG.error('promiseDelay error:', {
        extra: getSentryExtra(error)
      }));
    });
  };

  return new Promise((resolve, reject) => {
    check(resolve, reject).catch(error => {
      throw error;
    });
  });
};

const googleLoginClient = new HubSpotOnlyAppCookieLogin({
  loginRequest: (credentials, lb) => {
    const url = new Url('/login-api/v1/google/one-tap', {
      lb
    }).href;
    return noAuthApiClient.post(url, {
      data: credentials
    });
  },
  passThroughFallback: true
});
const microsoftLoginClient = new HubSpotOnlyAppCookieLogin({
  loginRequest: (credentials, lb) => {
    const url = new Url('/login-api/v1/microsoft/id-token-login', {
      lb
    }).href;
    return noAuthApiClient.post(url, {
      data: credentials
    });
  },
  passThroughFallback: true
});
const passwordLoginClient = new HubSpotOnlyAppCookieLogin({
  loginRequest: credentials => {
    const url = `${getFullUrl('app-api', {
      hubletOverride: credentials.hublet
    })}/login-api/v1/login`;
    return noAuthApiClient.post(url, {
      data: credentials
    });
  },
  passThroughFallback: true
});
export function googleLogin(idToken) {
  return googleLoginClient.login(Object.assign({}, {
    credential: idToken
  }));
}
export function microsoftLogin(idToken) {
  return microsoftLoginClient.login({
    idToken
  });
}
export function passwordLogin(email, password, hublet = HubletOption.na1, dispatch) {
  return retry({
    fn: () => {
      return passwordLoginClient.login({
        rememberLogin: true,
        email,
        password,
        hublet
      });
    },
    dispatch
  });
}
const LoginClient = {
  password: passwordLogin,
  google: googleLogin,
  microsoft: microsoftLogin
};
export default LoginClient;